import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { UserProfile } from "@/types/user";
import { RootState } from "@/store";

import { login } from "@/services/api/thunks/users";
import { ServerError } from "@/types/errors";

const initialState = {
  user: {} as UserProfile,
  error: {} as any,
  avatar: "",
  unReadMsSystemNum: 0, //未读系统消息

};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<UserProfile>) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = {} as UserProfile;
    },
    updateAvatar:(state,action:PayloadAction<string>)=>{
      state.avatar = action.payload
    },
    updateUnReadMsSystemNum:(state,action:PayloadAction<number>)=>{
      state.unReadMsSystemNum = action.payload
    }
  },
  extraReducers(builder) {
    builder
      .addCase(login.pending, (state) => {})
      .addCase(login.fulfilled, (state, action) => {
        state.user = action.payload;
        state.error = {} as ServerError;
        state.avatar = `/api/v4/users/${action.payload.id}/image`;
      })
      .addCase(login.rejected, (state, action) => {
        state.error = action.payload;
        state.user = {} as UserProfile;
        state.avatar = "";
      });
  },
});

// Action creators are generated for each case reducer function
export const { updateUser, clearUser,updateAvatar, updateUnReadMsSystemNum } = userSlice.actions;

export default userSlice.reducer;
export const selectUser = (state: RootState) => state.users.user;
export const selectAvatar = (state: RootState) => state.users.avatar;
export const selectUnReadMsSystemNum = (state: RootState) => state.users.unReadMsSystemNum;
